module.exports = __webpack_public_path__ + "static/media/HarryPotter.03a18ba8.png";